module.exports = __webpack_public_path__ + "static/img/ajq.48abc17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ajq.png
// module id = tmfq
// module chunks = 1